import { Controller } from "@hotwired/stimulus"

// Image upload with preview (replaces ImagesForm.jsx)
// Values: modelName, preview
// Targets: container, fileInput
export default class extends Controller {
  static values = { modelName: String, preview: String }
  static targets = ["container", "fileInput"]

  connect() {
    this.imageIndex = this.containerTarget.querySelectorAll("[data-image-item]").length
  }

  addFiles() {
    const files = this.fileInputTarget.files
    Array.from(files).forEach(file => {
      this.uploadFile(file)
    })
    // Reset file input so the same file can be re-selected
    this.fileInputTarget.value = ""
  }

  uploadFile(file) {
    const index = this.imageIndex++
    const placeholder = document.createElement("div")
    placeholder.dataset.imageItem = index
    placeholder.innerHTML = "<p>[Uploading...]</p>"
    this.containerTarget.appendChild(placeholder)

    const formData = new FormData()
    formData.append("image[file]", file)

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch("/images", {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        "Accept": "application/json"
      },
      body: formData
    })
      .then(response =>
        response.json().then(json => {
          if (response.ok) return json
          else throw new Error(json.file)
        })
      )
      .then(image => {
        placeholder.innerHTML = this.renderImage(image, index)
      })
      .catch(error => {
        placeholder.innerHTML = `<p>Error uploading: ${this.escapeHtml(error.message)}</p>`
      })
  }

  removeImage(event) {
    event.preventDefault()
    const item = event.target.closest("[data-image-item]")
    if (item) item.remove()
  }

  renderImage(image, index) {
    const modelName = this.modelNameValue

    let metaFields = ""
    if (this.previewValue !== "minimal") {
      metaFields = `<div class="mb-4 row row-gutters responsive-sm">
        <input type="hidden" name="${this.escapeHtml(modelName)}[images_attributes][${index}][id]" value="${image.id}" />
        <div class="col-50">
          <input type="text" name="${this.escapeHtml(modelName)}[images_attributes][${index}][description]" class="input-text" placeholder="Image description" value="${this.escapeHtml(image.description || '')}" />
        </div>
        <div class="col-50">
          <input type="text" name="${this.escapeHtml(modelName)}[images_attributes][${index}][source]" class="input-text mt-4" placeholder="Link to image source" value="${this.escapeHtml(image.source || '')}" />
        </div>
      </div>`
    }

    return `<div class="img-preview-container row row-between items-center mb-4">
        <input type="hidden" name="${this.escapeHtml(modelName)}[image_ids][]" value="${image.id}" />
        <div class="img-preview p-4">
          <img src="${this.escapeHtml(image.thumb_url)}" />
        </div>
        <a class="btn-icon-clear-danger mr-4" data-action="click->images-form#removeImage" href="">
          <svg class="icon icon-gray"><use href="/icons/__remixicon.sprite.svg?v=491#delete-bin-line"/></svg>
        </a>
      </div>
      ${metaFields}`
  }

  escapeHtml(str) {
    if (!str) return ""
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
